import React from "react";
import styled, { keyframes } from "styled-components";

const Eyes = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;
const Eye = styled.div`
  width: 200px;
  height: 200px;
  border: 5px solid black;
  border-radius: 50%;
  position: relative; // 눈알을 제어하기 위한 자식 눈동자의 위치를 기준시키기 위함.
`;

const moving = keyframes`
  from{
    top: 5%;
    left: 40%;
  }
  to{
    top: 50%;
    left: 60%;
  }
`;
const Ball = styled.div`
  width: 50px;
  height: 80px;
  background-color: blue;
  border-radius: 50%;
  position: absolute;
  animation: ${moving} 3s 0s linear alternate infinite;
`;

const Face = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Mouth = styled.div`
  width: 500px;
  height: 60px;
  border: 5px solid black;
  display: flex;
  justify-content: center;
  align-items: center; /* 수직 가운데 정렬 */
  margin-top: 2rem;
`;

const blink = keyframes`
0%, 100%{
    opacity: 1;
}
50%{
    opacity: 0;
}
`;

const reverse_blink = keyframes`
0%, 100%{
    opacity: 0;
}
50%{
    opacity: 1;
}
`;

const Teeth = styled.div`
  display: flex;
  width: 70px;
  height: 60px;
  background-color: orange;
  animation: ${blink} 2s 0s infinite;
`;

const ReverseTeeth = styled.div`
  display: flex;
  width: 70px;
  height: 60px;
  background-color: orange;
  animation: ${reverse_blink} 2s 0s linear infinite;
`;

function App() {
  return (
    <Face>
      <Eyes>
        <Eye>
          <Ball />
        </Eye>
        <Eye>
          <Ball />
        </Eye>
      </Eyes>
      <Mouth>
        <ReverseTeeth />
        <Teeth />
        <ReverseTeeth />
        <Teeth />
        <ReverseTeeth />
        <Teeth />
        <ReverseTeeth />
        <Teeth />
        <ReverseTeeth />
      </Mouth>
    </Face>
  );
}

export default App;
